import { render, staticRenderFns } from "./pay_out.vue?vue&type=template&id=988c0216&scoped=true&"
import script from "./pay_out.vue?vue&type=script&lang=js&"
export * from "./pay_out.vue?vue&type=script&lang=js&"
import style0 from "./pay_out.vue?vue&type=style&index=0&id=988c0216&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988c0216",
  null
  
)

export default component.exports